import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router } from 'react-router-dom';
import theme from './theme/theme';
import { FirebaseUserProvider } from './context/FirebaseUserContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ErrorBoundary from './components/ErrorBoundary';

import AppRoutes from './AppRoutes';
import { SignupProviders } from './features/Signup/context/SignupProviders';
import QueryTokenAuthHandler from './components/QueryTokenAuthHandler';

function App() {
  return (
    <ErrorBoundary
      onError={(error, errorInfo) => {
        // In production, send error to monitoring service
        console.error('App Error Boundary caught error:', {
          error: error.message,
          stack: error.stack,
          componentStack: errorInfo.componentStack,
          timestamp: new Date().toISOString(),
        });
      }}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <FirebaseUserProvider>
          <QueryTokenAuthHandler>
            <SignupProviders>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Router>
                  <AppRoutes />
                </Router>
              </LocalizationProvider>
            </SignupProviders>
          </QueryTokenAuthHandler>
        </FirebaseUserProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
